'use strict';

import cacheCookieHelper from '../components/CacheCookieHelper/CacheCookieHelper';

var $ = require('jquery'),
  cookies = require('js-cookie'),
  config = require('./config'),
  cookieBar,
  _ = require('underscore'),

  CookieBar = function() {};

CookieBar.prototype.initialize = function() {
  this.$el = $('.CookieBar');
  if (!this.isAccepted()) this.toggleClass();
  else this.removeTabIndexFromCookieBar();
  this.bindEvents();
};

CookieBar.prototype.bindEvents = function() {
  //  Accept this cookie.
  this.$el.find('.js-accept').on('click', _.bind(function(e) {
    e.preventDefault();
    this.removeTabIndexFromCookieBar();
    this.toggleClass();
    this.acceptCookie();
  }, this));
  // Show the content of the cookie bar.
  this.$el.find('.js-show-policy').on('click', _.bind(function(e) {
    e.preventDefault();
    $(e.currentTarget).toggleClass(config.classes.isActive);
    this.$el.find('.CookieBar-content').toggleClass(config.classes.isActive);
  }, this));
};

CookieBar.prototype.removeTabIndexFromCookieBar = function() {
  $('#cookiebar a').attr('tabIndex',-1);
};

CookieBar.prototype.toggleClass = function() {
  this.$el.toggleClass(config.classes.isAccepted);
};

CookieBar.prototype.acceptCookie = function() {
  cookies.set(config.cookies.acceptedCookiePolicy, true, { expires: 365 });
  if (cacheCookieHelper) {
    cacheCookieHelper.setCacheCookie();
  }
};

CookieBar.prototype.isAccepted = function() {
  return cookies.get(config.cookies.acceptedCookiePolicy);
};

cookieBar = new CookieBar();
cookieBar.initialize();



// WEBPACK FOOTER //
// ./assets/js/cookie-bar.js